module.exports = __webpack_public_path__ + "static/hero-36ed1001538217e83eaea954982d1826.png";